import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import ApplicationsTableRow from './ApplicationsTableRow';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import { ApplicationStatuses, CurrencyTypes } from '../../../lib/systemVariables';
import { TableViews } from '../../../lib/constants';

export default class ApplicationsTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = this.initialState;

        this.getTableRow = this.getTableRow.bind(this);
    }

    initialState = {
        selectedRecord: {},
        showModals: {
            confirmationModal: false
        }
    };

    updateApplication = async (application, update) => {
        const response = await this.props.updateApplication(application, update);

        return response;
    };

    deleteApplication = async () => {
        const { selectedRecord } = this.state;
        const response = await this.props.deleteApplication(selectedRecord.applicationId);

        return response;
    };

    getTableRow(application) {
        return <ApplicationsTableRow
            key={application.applicationId}
            view={this.props.view}
            status={this.props.status}
            application={application}
            isUSUser={this.props.isUSUser}
            permissions={this.props.userPermissions}
            fund={this.props.funds.find(f => f.key === application.fundId) ? this.props.funds.find(f => f.key === application.fundId).value : null}
            selectApplication={this.props.selectApplication}
            selected={this.props.selected.map(app => app.applicationId).indexOf(application.applicationId) >= 0}
            update={this.updateApplication}
            updating={this.props.updating[application.applicationId] === true}
            updateError={this.props.updating.hasOwnProperty(application.applicationId) && this.props.updating[application.applicationId] !== true}
            delete={() => {
                this.setState({ selectedRecord: application }, this.toggleModal.bind(this, "confirmationModal"));
            }} />;
    }

    render() {
        const { view, status, userPermissions: permissions } = this.props;
        const canApprove = permissions.approveFull || permissions.approveLimited;
        const canManage = permissions.manage;
        const canPrintOrWire = this.props.isUSUser ? permissions.print : permissions.wire;

        let columns = [
            { id: 'firstName', title: 'First Name', sortable: true },
            { id: 'lastOrOrgName', title: 'Last / Org Name', sortable: true },
            ...view === TableViews.Detailed ? [
                { id: 'address', title: 'Address', sortable: true },
                { id: 'teudatZahut', title: 'Teudat Zehut', sortable: true },
                { id: 'totalPaid', title: 'Total Paid', sortable: true, className: 'text-right' }
            ] : [],
            { id: 'applicationDate', title: 'Created / Review Date', sortable: true, defaultDirection: 'Descending' },
            { id: 'details', title: 'Details', sortable: true },
            { id: 'status', title: 'Status', sortable: true },
            { id: 'amount', title: 'Amount', sortable: true, className: 'text-right' },
            ...view === TableViews.Detailed
                ? [
                    { id: 'source', title: 'Source', sortable: true },
                    { id: 'note', title: 'Note', sortable: true },
                    { id: 'references', title: 'References', sortable: true }
                ]
                : [
                    { id: 'fund', title: 'Fund', sortable: true }
                ],
            { id: 'private', title: '', sortable: false, icon: "lock_outline" },
            { id: 'ach', title: 'ACH', sortable: false, icon: "account_balance" }
        ];

        if (canManage) {
            if (!status || status === ApplicationStatuses.New || status === ApplicationStatuses.Incomplete) {
                columns.push({ id: 'delete', title: '', sortable: false, icon: "delete_outline" });
            }
            if ((status === ApplicationStatuses.New && canApprove) || (status === ApplicationStatuses.Approved && canPrintOrWire)) {
                const selectableApps = this.props.data.records
                    .filter(app => {
                        const fundEntry = this.props.funds.find(f => f.key === app.fundId);
                        const fund = fundEntry ? fundEntry.value : null;
                        const cantSelect = ((status === ApplicationStatuses.New || status === ApplicationStatuses.Approved) && !app.amount)
                            || !fund
                            || (status === ApplicationStatuses.Approved && app.currency === CurrencyTypes.Dollar && !this.props.userPermissions.approveFull && app.amount > fund.limitedApprovalMax)
                            || (status === ApplicationStatuses.Approved && app.amount > (app.currency === CurrencyTypes.Shekel ? fund.wiringMax : fund.checkCuttingMax));
                        return !cantSelect;
                    });

                const selectedApps = this.props.selected
                    .filter(app => selectableApps.map(a => a.applicationId).indexOf(app.applicationId) >= 0);

                const checked = selectableApps.length && (selectedApps.length === selectableApps.length);

                columns.unshift(
                    {
                        id: 'select', title: '', sortable: false,
                        component: (!this.props.loading && this.props.data.records.length
                            && <div className={`custom-check-container ${!selectableApps.length ? "disabled" : ""}`}>
                                <input type="checkbox" id="applications-select-all" className="custom-check"
                                    checked={checked}
                                    disabled={!selectableApps.length}
                                    onChange={() => (
                                        !checked
                                            ? selectableApps.filter(app => selectedApps.map(a => a.applicationId).indexOf(app.applicationId) < 0)
                                            : selectableApps)
                                        .forEach(app => this.props.selectApplication(app))} />
                                <label htmlFor="applications-select-all" className="secondary-text" title="Select All" />
                            </div>)
                    }
                );
            }
        }

        return <div>
            <PaginatedTable
                name="applications"
                page={this.props.page}
                totalCount={this.props.data.totalCount}
                resultsView={this.props.resultsView}
                sort={this.props.sort}
                loading={this.props.loading}
                success={this.props.success}
                renderRow={this.getTableRow}
                columns={columns}
                records={this.props.data.records || []}
                sortData={this.props.updateTable}
                changeDataView={this.props.updateTable}
                loadData={this.props.getApplications}
                noReload={true} />

            <ConfirmationModal
                show={this.state.showModals.confirmationModal}
                message={this.state.selectedRecord.applicationId ? `Are you sure you want to permanently delete this ${this.state.selectedRecord.status.toLowerCase()} application?` : ''}
                close={() => {
                    this.setState({ selectedRecord: this.initialState.selectedRecord });
                    this.toggleModal("confirmationModal");
                }}
                confirm={this.deleteApplication}
                loading={this.props.removing.loading}
                success={this.props.removing.success}
                errorMessage={this.props.removing.message} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applications/ApplicationsTable.jsx